import {ChangeDetectionStrategy, Component} from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'myabvv-e-docs',
    standalone: true,
    templateUrl: './e-docs.component.html',
    imports: [RouterOutlet],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EDocsComponent {

}
